import { useState } from "react";

// A shallow, humanising visual break — six lifestyle photos of the Gate + Gather
// community moving slowly from right → left. Not a hero carousel, no arrows or
// dots. Duplicates the list twice in the DOM so the translate loop is seamless.
// prefers-reduced-motion falls back to a plain horizontally-scrollable strip.
const IMAGES = [
  { src: "/community/1-market-prep.webp", alt: "A grower arranging succulents on the tailgate of a ute above a view of the harbour and hills, dog watching" },
  { src: "/community/2-lomandra.webp",    alt: "A young grower dividing lomandra clumps by hand on a sunny lawn, potted divisions and paper carry bags lined up ready for the gate" },
  { src: "/community/3-seedlings.webp",   alt: "A grower pricking out vegetable seedlings in a warm sunlit greenhouse" },
  { src: "/community/4-seeds.webp",       alt: "A young grower sorting and packaging native seeds for spring 2026" },
  { src: "/community/5-bulbs.webp",       alt: "Dahlia, ranunculus and anemone tubers sorted into wooden crates with handwritten price cards" },
  { src: "/community/6-kowhai.webp",      alt: "A customer buying a flowering kōwhai from a grower at the roadside gate, cash exchange, dog watching" },
];

export default function CommunityMarquee() {
  const [paused, setPaused] = useState(false);
  const seq = [...IMAGES, ...IMAGES]; // duplicate for the seamless loop
  return (
    <section
      aria-label="A moving snapshot of the Gate + Gather community"
      className="community-marquee py-4"
      data-testid="community-marquee"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="community-marquee__track" style={{ animationPlayState: paused ? "paused" : "running" }}>
        {seq.map((img, i) => (
          <figure
            key={i}
            className="community-marquee__tile"
            aria-hidden={i >= IMAGES.length ? "true" : undefined}
          >
            <img src={img.src} alt={img.alt} loading="lazy" draggable={false} />
          </figure>
        ))}
      </div>
    </section>
  );
}
